import { connect, ConnectedProps } from "react-redux";

import { RecommendedFlightsCard } from "./component";
import { withRouter } from "react-router";
import { actions } from "../../../search/actions";
import { IStoreState } from "../../../../reducers/types";
import {
  getPackagesAvailabilityFareclassOptionFilter,
  getRecommendedFlights,
  getBenchmarkFlight,
} from "../../reducer";

const mapDispatchToProps = {
  setDepartureDate: actions.setDepartureDate,
  setReturnDate: actions.setReturnDate,
};
const mapStateToProps = (state: IStoreState) => {
  return {
    recommendedFlights: getRecommendedFlights(state),
    fareClassFilter: getPackagesAvailabilityFareclassOptionFilter(state),
    benchmarkFlight: getBenchmarkFlight(state),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type RecommendedFlightsCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedRecommendedFlightsCard = withRouter(
  connector(RecommendedFlightsCard)
);
